module.exports = __webpack_public_path__ + "img/info.17fb42f1.svg";